<template>
  <div class="animated fadeIn">
    <!--<button v-rightMenu="menudata">AA</button>-->
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="用户名/用户昵称/真实姓名/电话" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onFilterClick">查询</Button>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="addUserModal=true">添加用户</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <set-role-modal v-model="setRoleModal" :initValue="setRoleUserId"></set-role-modal>
    <add-user-modal v-model="addUserModal" @on-success="onSuccess"></add-user-modal>
    <user-detail-modal v-model="userDetailModal" :initValue="userDetailId" @on-success="onModifySuccess"></user-detail-modal>
    <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns" :tableName="$options.name" ></web-table-columns-modal>
  </div>
</template>

<script>
import SetRoleModal from '@/view/acl/components/set-role-modal'
import AddUserModal from '@/view/acl/components/add-user-modal'
import UserDetailModal from '@/view/acl/components/user-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'users',
  components: {
    SetRoleModal,
    AddUserModal,
    UserDetailModal
  },
  data () {
    return {
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],
      columnsList: [{ index: 1, title: 'h1', visible: false }, { index: 2, title: 'h2', visible: false }, { index: 3, title: 'h3', visible: false }],

      menudata: {
        // 菜单box的样式  Menu box style
        boxStyle: 'width:150px;background:#f55;',
        // 菜单选项的样式 Style of menu options
        optionStyle: 'color:#fff;line-height:30px;font-size:15px;',
        menus: [
          {
            /**
               * content 菜单显示的文字 <支持html>
               * callback：菜单点击要触发函数 需要在methods定义
               * style ： 本项菜单的单独样式 可以覆盖掉optionStyle
               * icon : icon图片地址
               * iconStyle: icon 图片的样式（例如大小等 直接作用于图片）
               * iconPosition : 支持left / right (其余全部按照left处理);
               * content The text displayed on the menu(can use html)
               * callback: Menu clicks to trigger functions need to be defined in methods
               * style : The single style of this menu can override option Style
               * icon : your icon's url
               * iconStyle : you icon's style ,is image's style
               * iconPosition :you can use left or right ;The rest are all processed according to left
               */
            /**
               * 字段(field)      类型(type)         是否可以为空(is can null)  默认值
               * content      [ html | text ]            Y          ""
               * callback      [ methods function ]         Y          return false
               * style          [ css ]             Y          ""
               * icon          [ url ]              Y          ""
               * iconStyle       [ css ]              Y          ""
               * iconPosition      [string]             Y          "left"
               */
            content: 'menu content',
            callback: 'callbackMethods',
            style: 'border-bottom:1px solid #fff;background:#333;line-height:30px;',
            icon: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2310514390,3580363630&fm=27&gp=0.jpg',
            iconStyle: 'width:20px;height:20px;',
            iconPosition: 'left'
          },
          {
            content: '右键菜单二',
            callback: 'otherMethods'
          }
        ]
      },

      sexFilter: null,
      stateFilter: null,

      // 添加用户
      addUserModal: false,

      // 设置角色
      setRoleModal: false,
      setRoleUserId: null,

      // 用户详细信息
      userDetailModal: false,
      userDetailId: null,

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      pageSize: 0,
      content: [],
      totalElements: 0,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '用户名',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          minWidth: 200
        },
        {
          title: '昵称',
          resizable: true,
          key: 'nickName',
          ellipsis: 'true',
          minWidth: 200
        },
        {
          title: '真实姓名',
          resizable: true,
          key: 'realName',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '头像',
          resizable: true,
          key: 'avatarUrl',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            if (params.row.avatarUrl) {
              return h('img',
                {
                  attrs: { src: params.row.avatarUrl },
                  style: { width: '45px', height: '45px' }
                })
            }
          }
        },
        {
          title: '性别',
          resizable: true,
          ellipsis: 'true',
          key: 'sex',
          minWidth: 90,
          filters: [
            { label: '男', value: 1 },
            { label: '女', value: 0 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.sexFilter = genQueryParam('sex', 'EQ', val[0])
            } else {
              this.sexFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.sex === 1) {
              return h('div', '男')
            } else if (params.row.sex === 0) {
              return h('div', '女')
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '电话',
          resizable: true,
          key: 'mobilePhoneNum',
          ellipsis: 'true',
          minWidth: 120
        },
        {
          title: '激活公众号',
          resizable: true,
          ellipsis: 'true',
          width: 110,
          render: (h, params) => {
            if (params.row.wechatServiceAccountOpenId) {
              return h('div', '是')
            } else {
              return h('div', '否')
            }
          }
        },
        {
          title: '注册时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDate',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '最后登录时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'lastLoginDatetime',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.lastLoginDatetime) {
              let d = new Date(params.row.lastLoginDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '所属分组',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'userGroupId',
          minWidth: 180,
          render: function (h, params) {
            if (params.row.userGroup) {
              return h('div', params.row.userGroup.name)
            }
          }
        },
        {
          title: '状态',
          resizable: true,
          tooltip: 'true',
          minWidth: 120,
          filters: [
            { label: '正常', value: 1 },
            { label: '禁用', value: 2 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = genQueryParam('state', 'EQ', val[0])
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            const task_status = params.row.state
            if (task_status == 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'green'
                  }
                }, '正常')
              ])
            } else if (task_status == 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    type: 'dot',
                    color: 'red'
                  }
                }, '禁用')
              ])
            }
          }
        },

        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 350,
          render: (h, params) => {
            const task_status = params.row.deleted
            if (task_status === false) {
              return h('div', [
                h('strong', {
                  style: {
                    marginRight: '5px'
                  }
                }, '禁用'),
                h('i-switch', {
                  style: {
                    marginRight: '10px'
                  },
                  props: {
                    type: 'primary',
                    value: params.row.state != 1
                  },
                  on: {
                    'on-change': (val) => {
                      let disp = ''
                      let state = 0

                      if (val) {
                        state = 1
                        disp = '<p>确认禁用该用户账号</p>'
                      } else {
                        state = 0
                        disp = '<p>确认解禁该用户账号</p>'
                      }

                      // if (params.row.state == false) {
                      this.$Modal.confirm({
                        title: '确认改变用户状态',
                        content: disp,
                        onOk: () => {
                          store.dispatch('UserServ_Disable', {
                            params: { id: params.row.id, disable: state }
                          }).then(() => {
                            this.$Message.success('修改成功')
                            this.refreshPage(this.pageFilter)
                          }).catch(err => {
                            this.$Message.error(err)
                            this.refreshPage(this.pageFilter)
                          })
                        },
                        onCancel: () => {
                          this.refreshPage(this.pageFilter)
                        }
                      })
                      // }
                    }
                  }
                }, ''
                ),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      console.log('this.setRoleModal = true')
                      this.setRoleUserId = params.row.id
                      this.setRoleModal = true
                    }
                  }
                }, '设置角色'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onResetPasswordBtnClick(params.row.id)
                    }
                  }
                }, '重置密码'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.userDetailId = params.row.id
                      this.userDetailModal = true
                    }
                  }
                }, '详细信息')
              ])
            } else if (task_status === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.onActiveBtnClick(params.row.id)
                    }
                  }
                }, '激活')
              ])
            }
          }// render
        }// {
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'getUserInfo',
      'UserServ_GetPage',
      'UserServ_SetRoles',
      'UserServ_GetRoles',
      'RoleServ_GetAll',
      'UserServ_ResetPassword',
      'UserServ_ActiveUser',
      'UserServ_Disable'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    onResetPasswordBtnClick (userId) {
      this.$Modal.confirm({
        title: '重置密码',
        content: '<p>是否确认重置此用户密码</p>',
        onOk: () => {
          store.dispatch('UserServ_ResetPassword', { params: { userId: userId } }).then(() => {
            this.$Message.success('重置密码成功')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let sortParam = null
      let queryParams = []

      if (this.sort !== null && this.sort !== undefined) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('id', false)
      }

      if (this.sexFilter) {
        queryParams.push(this.sexFilter)
      }
      if (this.stateFilter) {
        queryParams.push(this.stateFilter)
      }

      store.dispatch('UserServ_GetPage', {
        params: null,
        urlparams: {
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam,
          q: queryParams
        }
      }).then(() => {
        if (store.getters.get_User_GetPageResult) {
          this.totalElements = store.getters.get_User_GetPageResult.totalElements
          this.content = store.getters.get_User_GetPageResult.content
          this.pageSize = store.getters.get_User_GetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {

  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>

</style>
